<template>
  <div class="guide-wrapper">
    <div class="guide">
        <p>
        <span class="capitalLetter">C</span>on &laquo;La Mujer Cambiante&raquo;, la cordobesa <span class="highlight">Julia Osuna</span> (1981) presenta su primera retrospectiva,
        cuando se cumplen ahora 15 a&ntilde;os de sus inicios en el mundo de la <span class="highlight">traducci&oacute;n editorial</span>.
        La tan cacareada crisis de los 40 la pilla m&aacute;s ignorante y curiosa que nunca
        y decide dejar de luchar con el trastorno de personalidad m&uacute;ltiple al que la ha abocado su profesi&oacute;n
        para encarnar a una Mujer Cambiante, satisfecha de todas las caras que ha cultivado durante estos a&ntilde;os.
        </p>
        <p class="paragraph">
        Si pasamos una mirada ben&eacute;vola por las obras que nos muestra en esta exposici&oacute;n,
        vemos que en <span class="highlight title">La femme de la femme</span> presta su voz a las que tantos a&ntilde;os han estado silenciadas por la industria
        y que en nuestros d&iacute;as estallan mentes y escaparates por igual. En un salto mortal la encontramos en
        <span class="highlight title">Delitos sin faltas</span>, intercambiando malas caras con criminales y agentes de las fuerzas del orden
        como la quinqui con las arrugas m&aacute;s marcadas del m&oacute;dulo.

        Con <span class="highlight title">Cari&aacute;tide</span> se vuelve pl&aacute;stica y se pincela para integrarse como un trazo m&aacute;s en vi&ntilde;etas e ilustraciones.
        <span class="highlight title">I &#38; J</span> son sus gemelas, su lado m&aacute;s tierno, su lado m&aacute;s rebelde y adolescente.
        <span class="highlight title">Sui generis</span> es el culmen de su personalidad multifac&eacute;tica,
        mientras que de la mano de <span class="highlight title">La signora Cronopio</span> nos abre la puerta a las reflexiones sobre el oficio que ha puesto en negro sobre blanco en distintos medios.
        </p>
        <p class="paragraph">
        Quiz&aacute; a quienes visiten la exposici&oacute;n pueda desconcertarles la falta de hilo conductor, el baile de m&aacute;scaras, los donde dije digo&#8230;,
        pero tal vez deban preguntarse si no es nuestra &eacute;poca un poco as&iacute; y no puede la artista por m&aacute;s que reflejarla.
        Fluye, pajarillo, fluye, fluye, fluye&#8230;
        </p>
        <p>
        <center class="mail">
            <a class="link" href="mailto:julia@lamujercambiante.es">julia@lamujercambiante.es</a>
            <br />
            <router-link :to="{ name: 'Exhibition'}"><img class="expo" alt="Hoja de sale" src="../assets/bg_link_expo.png"/></router-link>
        </center>
        </p>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      cvPath: process.env.VUE_APP_API_BASE_URL + '/doc/CV_JuliaOsuna_Cambiante_TRAD_pq.pdf'
    }
  }
}
</script>

<style scoped lang="scss">

$debug: false;

.capitalLetter
{
   float:left;
   color:#69303e;
   font-size:80px;
   line-height:45px;
   padding:2px;
   font-family:times;
   margin-right: 10px;
}

.mail {
  color:#69303e;
  font-size: 24px;
  font-weight: bold;
}

.mail a {
  text-decoration: none;
  color:#69303e;
}

.mail a:hover {
  text-decoration: underline
}

.cv {
  filter: drop-shadow(0px 0px 6px #9e5d67);
  margin-top: 0px;
  margin-bottom: 20px;
}

.expo {
  filter: drop-shadow(0px 0px 6px #9e5d67);
  margin-top: 17px;
  margin-bottom: 20px;
}

.highlight {
   color:#69303e;
}

.title {
   font-style: italic;
}

.guide-wrapper {
  @if $debug == true {
    border: solid 1px #0000FF;
    background-color: beige;
  }

  height: 10vh;
  width: 100%;
  // margin-top: 2.5em;
  margin-bottom: 20px;
}

.guide {
  @if $debug == true {
    border: solid 1px #00FF00;
  }

  // background: #b49898;
  background-size: cover;

  // display: flex;
  justify-content: center;
  text-align: justify;
  margin: auto;
}

.paragraph {
  text-indent: 20px;
}

@include respond-above(lg) {
  .guide-wrapper {
    margin-top: 2.5em;
    padding: 1.0em;
  }

  .guide {
    background-image: url("../assets/bg_guide.jpg");
    width: 1000px;
    padding-top: 80px;
    padding-left: 90px;
    padding-right: 50px;
  }
}

@include respond-between(md,lg) {
  .guide-wrapper {
    margin-top: 0em;
    padding: 2%;
  }
  .guide {
    background-image: url("../assets/bg_guide.jpg");
    padding-top: 70px;
    // margin-top: 60px;
    padding-left: 90px;
    padding-right: 5%;
    // background-position: -50px 0px;
  }
}

@include respond-below(md) {
  .guide-wrapper {
    margin-top: 0em;
    padding: 2%;
  }
  .guide {
    background-image: url("../assets/bg_guide-xs.jpg");
    padding-top: 10px;
    // margin-top: 60px;
    padding-left: 5%;
    padding-right: 5%;
  }
  .expo {
  width: 90%;
  }
}

</style>
